import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-list-chat-conversation',
  templateUrl: './list-chat-conversation.component.html',
  styleUrls: ['./list-chat-conversation.component.scss']
})
export class ListChatConversationComponent implements OnInit {
  @Input() clientChat;
  @Output() chatEmitter = new EventEmitter();
  content = '';
  time = '';
  clientId : number;
  name = '';

  constructor() { }

  ngOnInit() {
    console.log(this.clientChat)
    if(this.clientChat.val && this.clientChat.val.name) {
      this.name = this.clientChat.val.name
    }
    // @ts-ignore
    if (this.clientChat.lastConversation.last_activity && this.clientChat.lastConversation.last_activity.time ){
      // @ts-ignore
      this.time = moment(this.clientChat.lastConversation.last_activity.time).format('ll').substr(0, 6);
    }
    if (this.clientChat.lastConversation.last_activity && this.clientChat.lastConversation.last_activity.content){
      this.content = this.clientChat.lastConversation.last_activity.content.length > 20
        ? `${this.clientChat.lastConversation.last_activity.content.substr(0, 20)}... -  ${this.time}` :
        `${this.clientChat.lastConversation.last_activity.content} - ${this.time}` ;
    }
  }
  selectConversation(client){
    this.chatEmitter.emit(client)
  }
}
